import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { http } from "../../utils";
import { uploadImage } from "../helper/upload-image";

async function fetchProductGroupCategory() {
  const { data } = await http("/admin/product-group-category");
  return data?.data;
}

export function useProductGroupCategory({ suspense = true } = {}) {
  const { data, ...rqResult } = useQuery(
    ["product-group-category"],
    fetchProductGroupCategory,
    {
      suspense,
    }
  );

  return {
    ...rqResult,
    data: data ?? [],
  };
}

async function deleteProductGroupCategory(categoryId) {
  const data = await http(`/admin/product-group-category/${categoryId}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteProductGroupCategory() {
  const queryClient = useQueryClient();

  return useMutation(deleteProductGroupCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries(["product-group-category"]);
    },
  });
}

async function addProductGroupCategory(formData) {
  const { img, ...form } = formData;
  const imageData = new FormData();
  imageData.append("file", img);

  const { data: image } = await uploadImage(imageData);

  const data = await http(`/admin/product-group-category`, {
    data: {
      name: form?.name,
      img: image?.publicUrl,
    },
  });

  return data;
}

export function useAddProductGroupCategory() {
  const queryClient = useQueryClient();

  return useMutation(addProductGroupCategory, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-group-category"]);
    },
  });
}

export function useUpdateProductGroupCategory() {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const { img, ...form } = data;
      const imageData = new FormData();
      imageData.append("file", img);
      const isImageUploaded = img instanceof File;
      const res = isImageUploaded ? await uploadImage(imageData) : form?.img;
      return http(`/admin/product-group-category/${form.id}`, {
        method: "PUT",
        data: {
          name: form?.name,
          img: res?.data?.publicUrl ?? form?.img,
          isAutoOrderAvailable: form?.isAutoOrderAvailable,
        },
      });
    },
    {
      onSuccess: async () =>
        await queryClient.invalidateQueries(["product-group-category"]),
    }
  );
}
